// Shared option arrays used across multiple EditPageDescriptions files.
// Only constants that are exactly duplicated are extracted here.

// Max length of the "Visit Time Constraints" input. Caps it client-side so a value that would
// overflow the Service.TimeConstraints DB column can't be entered and rejected at save time.
// Keep in sync with that column's length (nvarchar(1000)) — see db/caspian/tables/Service.sql (CD-5414).
export const timeConstraintsMaxLength = 1000;

// === Location Options ===
export const specialLocationsOptionsArray = [
  { value: 'Nevada', label: 'Nevada' },
  { value: 'Hawaii', label: 'Hawaii' },
  { value: 'Alaska', label: 'Alaska' },
  { value: 'Taiwan', label: 'Taiwan' },
  { value: 'HongKong', label: 'HongKong' },
  { value: 'China mainland', label: 'China mainland' },
  { value: 'Macao', label: 'Macao' },
  { value: 'Japan', label: 'Japan' },
  { value: 'Australia', label: 'Australia' },
  { value: 'Vietnam', label: 'Vietnam' },
  { value: 'South Korea', label: 'South Korea' },
  { value: 'Cambodia', label: 'Cambodia' },
];

export const locationTypeOptionsArray = [
  { value: 'Metropolitan', label: 'Metropolitan' },
  { value: 'Rural', label: 'Rural' },
  { value: 'Suburbs', label: 'Suburbs' },
  { value: 'Other', label: 'Other' },
];

export const locationListSourceArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'ClientProvides', label: 'Client provides' },
  { value: 'ToBeSearched', label: 'To be searched' },
  { value: 'BARECreatesLocationList', label: 'BARE creates location list' },
  { value: 'Other', label: 'Other' },
];

// === Communication Options ===
export const viaEmailChatBotOrOtherOptionsArray = [
  { value: 'Email', label: 'Email' },
  { value: 'ChatBot', label: 'Chat Bot' },
  { value: 'Other', label: 'Other' },
];

export const smsOrEmailArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'SMS', label: 'SMS' },
  { value: 'Email', label: 'Email' },
  { value: 'Other', label: 'Other' },
];

export const smsChatWhatsappOptionsArray = [
  { value: 'SMS', label: 'SMS' },
  { value: 'WeChat', label: 'We Chat' },
  { value: 'WhatsApp', label: 'WhatsApp' },
  { value: 'Other', label: 'Other' },
];

// === Survey Options ===
export const surveyDistributionOptionsArray = [
  { value: 'Email', label: 'Email' },
  { value: 'QRInStore', label: 'QR in-store' },
  { value: 'CompanyWebsite', label: 'Company Website' },
  { value: 'SocialMedia', label: 'Social Media' },
  { value: 'Other', label: 'Other' },
];

export const bareOrClientSendArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'BARESend', label: 'BARE send' },
  { value: 'ClientSend', label: 'Client send' },
  { value: 'Other', label: 'Other' },
];

export const b2bOrB2cOptionsArray = [
  { value: 'B2B', label: 'B2B' },
  { value: 'B2C', label: 'B2C' },
  { value: 'Other', label: 'Other' },
];

export const bareOrClientSurveyArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'BARE', label: 'BARE' },
  { value: 'Client', label: 'Client' },
];

export const bareBrandedOptionsArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'BareBranded', label: 'Bare Branded' },
  { value: 'CompanyBranded', label: 'Company Branded' },
];

// === Store / Audit Options ===
export const inStoreOrOnlineOptionsArray = [
  { value: 'InStore', label: 'In-store' },
  { value: 'Online', label: 'Online' },
  { value: 'Phone', label: 'Phone' },
  { value: 'Other', label: 'Other' },
];

export const storeTypesArray = [
  { value: 'RetailStores', label: 'Retail stores' },
  { value: 'Supermarket', label: 'Supermarket' },
  { value: 'ConvenienceStores', label: 'Convenience stores' },
  { value: 'Hypermarkets', label: 'Hypermarkets' },
  { value: 'SpecialtyFoodStores', label: 'Specialty food stores' },
  { value: 'Other', label: 'Other' },
];

export const toolsArray = [
  { value: 'BarcodeScanner', label: 'Barcode scanners' },
  { value: 'MobileApps', label: 'Mobile apps' },
  { value: 'Other', label: 'Other' },
];

export const dataPointsArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'SKUCounts', label: 'SKU counts' },
  { value: 'Discrepancies', label: 'Discrepancies' },
  { value: 'ShelfPlacement', label: 'Shelf placement' },
  { value: 'PricingTags', label: 'Pricing tags' },
  { value: 'Other', label: 'Other' },
];

export const announcedOrUnannouncedArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'Announced', label: 'Announced' },
  { value: 'Unannounced', label: 'Unannounced' },
];

export const auditScheduleArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'Adhoc', label: 'Adhoc' },
  { value: 'ScheduledDaily', label: 'Scheduled - Daily' },
  { value: 'ScheduledWeekly', label: 'Scheduled - Weekly' },
  { value: 'ScheduledMonthly', label: 'Scheduled - Monthly' },
];

export const operationalScopeArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'ClientTeamSelfAudit', label: 'Client team (Self Audit)' },
  { value: 'ExternalEvaluators', label: 'External evaluators (MS)' },
  { value: 'Mixed', label: 'Mixed' },
];

// === Pricing Options ===
export const pricingAspectsArray = [
  { value: 'CashDiscounts', label: 'Cash discounts' },
  { value: 'LeasingStructures', label: 'Leasing structures' },
  { value: 'PromotionalOffers', label: 'Promotional offers' },
  { value: 'CompetitorComparisons', label: 'Competitor comparisons' },
  { value: 'Other', label: 'Other' },
];

export const directedPricingArray = [
  { value: 'DirectedPriceGathering', label: 'Directed price gathering' },
  { value: 'CategoryScanning', label: 'Category scanning' },
  { value: 'FullStoreScanning', label: 'Full store scanning' },
  { value: 'Other', label: 'Other' },
];

export const kpisBehaviorArray = [
  { value: 'AccuracyOfDisplayedPrices', label: 'Accuracy of displayed prices' },
  { value: 'Transparency', label: 'Transparency' },
  { value: 'NegotiationBehavior', label: 'Negotiation behaviour' },
  { value: 'Other', label: 'Other' },
];

// === Intercepts Options ===
export const tabletOrPaperOptionsArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'Tablet', label: 'Tablet' },
  { value: 'Paper', label: 'Paper' },
  { value: 'Other', label: 'Other' },
];

export const locationOrEntranceOptionsArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'InTheLocation', label: 'In the location/store' },
  { value: 'Entrance', label: 'Entrance' },
  { value: 'Other', label: 'Other' },
];

// === Online Reputation Options ===
export const monitoringTypeArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'OnlineMonitoring', label: 'Online monitoring' },
  { value: 'OnlineReputationManagement', label: 'Online Reputation management' },
];

export const platformsArray = [
  { value: 'GoogleReviews', label: 'Google Reviews' },
  { value: 'Yelp', label: 'Yelp' },
  { value: 'TripAdvisor', label: 'TripAdvisor' },
  { value: 'Facebook', label: 'Facebook' },
  { value: 'Instagram', label: 'Instagram' },
  { value: 'TikTok', label: 'TikTok' },
  { value: 'TwitterX', label: 'Twitter/X' },
  { value: 'LinkedIn', label: 'LinkedIn' },
];

export const frequencyArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'Daily', label: 'Daily' },
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Monthly', label: 'Monthly' },
];

export const scopeArray = [
  { value: 'ReviewsAndRatings', label: 'Reviews and ratings' },
  { value: 'SocialMediaMentions', label: 'Social media mentions and comments' },
  { value: 'BlogPostsAndNews', label: 'Blog posts or news articles' },
  { value: 'IndustryMentions', label: 'Industry mentions' },
  { value: 'Hashtags', label: 'Hashtags' },
];

// === Business Intelligence (tab-specific) Options ===
export const biReportingToolArray = [
  { label: 'Choose one...', value: '', disabled: true },
  { value: 'Domo', label: 'Domo' },
  { value: 'PowerBI', label: 'PowerBI' },
  { value: 'Prism', label: 'Prism' },
  { value: 'Other', label: 'Other' },
];
export const biFrequencyOfUpdateArray = [
  { label: 'Choose one...', value: '', disabled: true },
  { value: 'Daily', label: 'Daily' },
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Quarterly', label: 'Quarterly' },
  { value: 'Other', label: 'Other' },
];
export const biDataSourcesArray = [
  { label: 'Choose one...', value: '', disabled: true },
  { value: 'Neticle', label: 'Neticle' },
  { value: 'DataPure', label: 'Data Pure' },
  { value: 'ReplyPro', label: 'Reply Pro' },
  { value: 'PulseBareIf', label: 'Pulse/BARE-ify' },
  { value: 'Other', label: 'Other' },
];
export const biMainMetricsArray = [
  { value: 'CSAT', label: 'CSAT' },
  { value: 'CES', label: 'CES' },
  { value: 'NPS', label: 'NPS' },
  { value: 'Other', label: 'Other' },
];
export const biInteractiveFeaturesArray = [
  { value: 'DataAlerts', label: 'Data Alerts' },
  { value: 'DynamicKPIs', label: "Dynamic KPI's" },
];
export const biOutputArray = [
  { label: 'Choose one...', value: '', disabled: true },
  { value: 'ClientDashboard', label: 'Client dashboard' },
  { value: 'PowerBI', label: 'Power BI' },
  { value: 'PowerPoint', label: 'PowerPoint' },
  { value: 'Excel', label: 'Excel' },
  { value: 'Prism', label: 'Prism' },
  { value: 'Other', label: 'Other' },
];
export const biMspPlatformArray = [
  { label: 'Choose one...', value: '', disabled: true },
  { value: 'Apollo', label: 'Apollo' },
  { value: 'RMX', label: 'RMX' },
  { value: 'Prism', label: 'Prism' },
  { value: 'BAREify', label: 'BARE-ify' },
  { value: 'DataPure', label: 'Data Pure' },
  { value: 'ReplyPro', label: 'Reply Pro' },
  { value: 'Other', label: 'Other' },
];
export const comparisonArray = [
  { value: 'Wave', label: 'Wave' },
  { value: 'Region', label: 'Region' },
  { value: 'Client', label: 'Client' },
  { value: 'Other', label: 'Other' },
];
export const servicesNeedArray = [
  { value: 'Summarization', label: 'Summarization' },
  { value: 'TopicModeling', label: 'Topic Modeling' },
  { value: 'EmotionAnalytics', label: 'Emotion Analytics' },
  { value: 'AspectBasedSentiment', label: 'Aspect-Based Sentiment Analysis' },
  { value: 'Other', label: 'Other' },
];
export const regularityArray = [
  { label: 'Choose one...', value: '', disabled: true },
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Quarterly', label: 'Quarterly' },
  { value: 'Yearly', label: 'Yearly' },
  { value: 'Other', label: 'Other' },
];

// === BI Reporting Options ===
export const biToolArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'Domo', label: 'Domo' },
  { value: 'PowerBI', label: 'PowerBI' },
  { value: 'Other', label: 'Other' },
];

export const frequencyUpdateArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'OncePerYear', label: 'Once per year' },
  { value: 'EveryMonth', label: 'Every month' },
  { value: 'Other', label: 'Other' },
];

export const dataSourcesArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'Neticle', label: 'Neticle' },
  { value: 'DataPure', label: 'DataPure' },
  { value: 'Other', label: 'Other' },
];

export const mainMetricsArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'CSAT', label: 'CSAT' },
  { value: 'CES', label: 'CES' },
  { value: 'NPS', label: 'NPS' },
  { value: 'Other', label: 'Other' },
];

export const visualizationsArray = [
  { value: 'Histogram', label: 'Histogram' },
  { value: 'HeatMapping', label: 'Heat Mapping' },
  { value: 'DrillDown', label: 'Drill Down' },
  { value: 'FunnelChart', label: 'Funnel chart' },
  { value: 'MapChart', label: 'Map chart' },
  { value: 'BubbleChart', label: 'Bubble chart' },
  { value: 'Other', label: 'Other' },
];

export const interactiveFeaturesArray = [
  { value: 'NavigationBar', label: 'Navigation Bar' },
  { value: 'Alerts', label: 'Alerts' },
  { value: 'Variable', label: 'Variable' },
];

// === BI Analysis Options ===
export const templateArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'BARE', label: 'BARE' },
  { value: 'CLIENT', label: 'CLIENT' },
];

export const outputArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'ClientDashboard', label: 'Client dashboard' },
  { value: 'PowerBI', label: 'Power BI' },
  { value: 'PowerPoint', label: 'PowerPoint' },
  { value: 'Excel', label: 'Excel' },
  { value: 'Other', label: 'Other' },
];

// === BI Analysis Options ===
export const mspPlatformArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'Apollo', label: 'Apollo' },
  { value: 'Domo', label: 'Domo' },
  { value: 'RMX', label: 'RMX' },
  { value: 'Prism', label: 'Prism' },
  { value: 'Prism Intl.', label: 'Prism Intl.' },
  { value: 'Other', label: 'Other' },
];

export const deliveryPlatformArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'Domo', label: 'Domo' },
  { value: 'PowerPoint', label: 'PowerPoint' },
  { value: 'Excel', label: 'Excel' },
  { value: 'Other', label: 'Other' },
];

// === Online Reputation Reporting Options ===
export const reportingRequirementsArray = [
  { value: 'SentimentAnalysis', label: 'Sentiment analysis summary' },
  { value: 'VolumePerPlatform', label: 'Volume of mentions per platform' },
  { value: 'TopThemes', label: 'Top positive/negative themes' },
  { value: 'Other', label: 'Other' },
];

export const pricingAuditDataCaptureMethodArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'BARELens', label: 'BARE lens (Data Pure)' },
  { value: 'Prism', label: 'Prism' },
  { value: 'ClientSoftware', label: 'Client software' },
  { value: 'Other', label: 'Other' },
];

// === General / Reporting Options ===
export const reportingArray = [
  { value: 'Portal', label: 'Portal' },
  { value: 'Dashboard', label: 'Dashboard' },
  { value: 'API', label: 'API' },
  { value: 'Excel', label: 'Excel' },
  { value: 'Other', label: 'Other' },
];

// === In-Person Phone Call Options ===
export const prePostPhoneCallArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'PreCall', label: 'Pre-Call' },
  { value: 'PostCall', label: 'Post-Call' },
];

// === Face-to-Face Intercept Options ===
export const surveyReportDeliverArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'UponSubmission', label: 'Upon Submission' },
  { value: 'DataQuality', label: 'Data Quality' },
];

// === BARE-IFY Options ===
export const exportsRequiredArray = [
  {
    label: 'Choose one...',
    value: '',
    disabled: true,
  },
  { value: 'Custom', label: 'Custom' },
  { value: 'Excel', label: 'Excel' },
];
